import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class NavigationService {

  home: Navigation = { back: '', next: 'welcome' }
  welcome: Navigation = { back: '/', next: 'student' }
  student: Navigation = { back: '/welcome', next: '/student-address' }
  studentAddress: Navigation = null;
  firstGuardian: Navigation = { back: '/student-address', next: '/emergency-contact' }
  emergencyContact: Navigation = null;
  providerAndPharmacy: Navigation = { back: '/emergency-contact', next: '/insurance' }
  hippa: Navigation = { back: '/insurance', next: '/my-norton-chart' }
  myNortonChart: Navigation = { back: '/hipaa', next: '/medical-and-surgical-history' }
  medicalAnsSurgicalHistory: Navigation = null;
  tobaccoAlcohol = { back: '/medications', next: '/authorize' } //*
  permissionToExamine: Navigation = null;
  authorize: Navigation = null;
  signature: Navigation = { back: '/authorize', next: '/thank-you' }
  insurance: Navigation = { back: 'provider-and-pharmacy', next: '/hipaa' }

  constructor() { }

  setButtons(isStaff: boolean) {
    this.studentAddress = { back: '/student', next: isStaff ? '/emergency-contact' : '/first-guardian'}
    this.emergencyContact = { back: isStaff ? '/student-address' : '/first-guardian', next: '/provider-and-pharmacy' }
    this.medicalAnsSurgicalHistory = { back: '/my-norton-chart', next: isStaff ? '/tobacco-alcohol' : '/permission-to-examine' }
    this.permissionToExamine = { back: isStaff ? '/tobacco-alcohol' : 'medications', next: '/authorize' }
    this.authorize = { back: isStaff ? '/tobacco-alcohol' : '/permission-to-examine', next: '/signature' }
  }
}

export class Navigation {
  back: string;
  next: string;
}
